import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

import { FeatureTitle, FeatureDescription } from '@/components/Feature';

export const StyledFeatureTitle = styled(FeatureTitle)`
  color: rgb(${getToken('color-text-primary')});
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  text-transform: none;
  font-size: 26px;
  line-height: 39px;

  ${screen.md} {
    font-size: 26px;
    line-height: 39px;
  }

  ${screen.lg} {
    font-size: 38px;
    line-height: 47.5px;
    margin: 0 0 36px;
  }

  ${screen.xxlg} {
    font-size: 48px;
    line-height: 60px;
    margin: 0 0 40px;
  }
`;

export const StyledFeatureDescription = styled(FeatureDescription)`
  color: rgb(${getToken('color-text-primary')});
  font-family: ${getToken('platform-font-default')};
  font-weight: ${getToken('font-weight-regular')};
  text-align: center;
  margin: 0 0 auto;
  font-size: 14px;
  line-height: 21px;

  span {
    display: none;
  }

  ${screen.md} {
    text-align: start;
    font-size: 14px;
    line-height: 21px;

    span {
      display: inline-block;
    }
  }

  ${screen.lg} {
    font-size: 20px;
    line-height: 36px;
  }

  ${screen.xxlg} {
    font-size: 20px;
    line-height: 36px;
  }
`;

export const StyledImages = styled.img`
  height: 181px;
  width: 312px;
  margin-top: 5px;

  ${screen.md} {
    height: 187px;
    width: 330px;
    margin-top: 16px;
  }

  ${screen.lg} {
    height: 270px;
    width: 476px;
  }

  ${screen.xxlg} {
    height: 381px;
    width: 670px;
    margin-top: 36px;
  }
`;
